import type { FgaAssignableRelation } from './generated/model'

/**
 * The bill permission vocabulary a permission set configures. Orthogonal rather than tiered, so one
 * toggle is one tuple. Seeing the record is not among them — it derives from holding any permission
 * at all.
 */
export const BILL_PERMISSIONS = ['edit_before_accept', 'accept'] as const

export type BillPermission = (typeof BILL_PERMISSIONS)[number]

export const billGrantsRelation = (
  permission: BillPermission
): Extract<FgaAssignableRelation<'bill_permission_set'>, `grants_${string}`> => `grants_${permission}`
